import { useState, useEffect } from "react"

// components
import Checkbox from "components/Checkbox/Checkbox"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

// styles
import "./RJCheckboxGroup.scss"

const RJCheckboxGroup = (props) => {
  let { id, carbonProps, options, value, onChange, invalid } = props
  const [items, setItems] = useState([])
  const [isNone, setNone] = useState(false)

  useEffect(() => {
    if (value?.length === 1 && value[0] === "None") {
      setNone(true)
    }
    if (options && options.enumOptions) {
      let newItems = options.enumOptions.map((option) => {
        let isChecked = false
        if (value && value.length > 0 && value.some) {
          isChecked = value?.some((item) => option.value === item)
        }
        return { id: option.value, text: option.value, isChecked }
      })
      setItems(newItems)
    }
  }, [value])

  const handleChange = (e, value) => {
    let temp = [...props.value]

    if (isNone === true) {
      setNone(false)
      let foundItem = temp.find((item) => item === value)
      if (!foundItem) {
        let selectedItems = []
        let newItems = items.map((option) => {
          // Update Controlled state items
          let newOption = { ...option }
          if (option.text === value) newOption.isChecked = true
          if (newOption.isChecked === true) selectedItems.push(option.text)
          return newOption
        })
        setItems(newItems)
        console.log("Checkbox useEffect >> onChange")
        onChange(selectedItems)
      }
    } else if (e && isNone === false) {
      let foundItem = temp.find((item) => item === value)
      if (!foundItem) {
        let selectedItems = []
        let newItems = items.map((option) => {
          // Update Controlled state items
          let newOption = { ...option }
          if (option.text === value) newOption.isChecked = true
          if (newOption.isChecked === true) selectedItems.push(option.text)
          return newOption
        })
        setItems(newItems)
        console.log("Checkbox useEffect >> onChange")
        onChange(selectedItems)
      }
    } else {
      let foundIndex = temp.findIndex((item) => item === value)
      if (foundIndex !== -1) {
        let selectedItems = []
        let newItems = items.map((option) => {
          // Update Controlled state items
          let newOption = { ...option }
          if (option.text === value) newOption.isChecked = false
          if (newOption.isChecked === true) selectedItems.push(option.text)
          return newOption
        })
        setItems(newItems)
        console.log("Checkbox useEffect >> onChange")
        onChange(selectedItems)
      }
    }
  }

  const handleNone = (e) => {
    if (e) {
      let newItems = items.map((option) => {
        return { id: option.id, text: option.text, isChecked: false }
      })
      setItems(newItems)
      console.log("Checkbox useEffect >> onChange")
      onChange(["None"])
      setNone(true)
    } else {
      setNone(false)
      onChange([])
    }
  }

  let variant

  if (invalid) {
    variant = "error"
  }

  return (
    <div
      id={id + "-field"}
      className="rjs-checkbox-group"
    >
      <Checkbox
        id={`${props.id}-checkbox-none`}
        label={"None"}
        checked={isNone}
        onChange={(e) => handleNone(e.target.checked)}
      />
      <div className="rj-checkbox-group-divider" />
      {items.map((item, i) => {
        return (
          <Checkbox
            key={`${id}-${i}`}
            id={`${id}-checkbox-${item.id}-${i}`}
            label={item.text}
            disabled={carbonProps.disabled}
            checked={item.isChecked}
            onChange={(e) => handleChange(e.target.checked, item.text)}
          />
        )
      })}
    </div>
  )
}

export default InputWrapper(RJCheckboxGroup)
